function changeVariantAddToCart($this){
    var formid                  = $this.getAttribute('data-formid');
    var variantid               = $this.getAttribute('data-variant-id');
    var variantprice            = $this.getAttribute('data-variant-price');
    var variantcompareprice     = $this.getAttribute('data-variant-compare-at-price');
    var form                    = document.getElementById(formid);
    var inputidproduct          = form.querySelector('input[name="id"]');

    inputidproduct.value        = variantid;

    form.querySelector('.product-price__price--sale').innerHTML = variantprice;
    console.log(variantcompareprice);
    if( variantcompareprice != '' ){
        form.querySelector('.product-price__price--regular').innerHTML = variantcompareprice;
        form.querySelector('.product-price__price--sale').classList.add('pricediscount');
    } else {
        form.querySelector('.product-price__price--regular').innerHTML = '';
        form.querySelector('.product-price__price--sale').classList.remove('pricediscount');
    }

    var currentActive = form.querySelector('.variants .active');
    if (currentActive) currentActive.classList.remove('active');
    $this.classList.add('active');
}

function getCurrentSecondsInTheCurrentMonth() {
    var now = new Date().getTime(),
        monthStart = new Date();

    monthStart.setDate(1);
    monthStart.setHours(0);
    monthStart.setMinutes(0);
    monthStart.setSeconds(0);
    monthStart.setMilliseconds(0);
    return Math.floor((now - monthStart.getTime()) / 1000);
}

function animateValue(id, start, end, duration, lastnumber) {
    if (start === end) return;
    var range = end - start;
    var current = start;
    var increment = end > start? 1 : -1;
    var stepTime = Math.abs(Math.floor(duration / range));
    var obj = document.getElementById(id);
    var timer = setInterval(function() {
        current += increment;
        obj.innerHTML = current;
        if (current == end) {
            clearInterval(timer);
            if( lastnumber != undefined ){
                obj.innerHTML = lastnumber;
            }
        }
    }, stepTime);

    obj.innerHTML = "100,12";
}

function getAnimateCompteurs(inbloucle = false){
    var compteurs = document.querySelectorAll('.compteur');
    if( compteurs.length > 0 ){

        compteurs.forEach(function(compteur){
            var champhistorique = parseInt(compteur.getAttribute('data-historique'));
            var champprevisionnel = parseInt(compteur.getAttribute('data-previsionnel'));

            // calculer l'icrementation previsionnel chaque seconde
            var bnDaysInMonth = new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).getDate();
            var previsionEachSecond = champprevisionnel / bnDaysInMonth / 24 / 60 / 60;

            // récuperer valeur previsionnel à la seconde en cours
            var valeurprevisionnelle = previsionEachSecond * getCurrentSecondsInTheCurrentMonth();

            // Ajout de l'historique pour le résultat final
            var finalvalue = (valeurprevisionnelle + champhistorique) / 1000;
            var finalvalueToScreenInt = parseInt(finalvalue);
            var finalvalueToScreen = finalvalue.toFixed(2).replace('.', ',');
            if( inbloucle ){
                compteur.innerHTML = finalvalueToScreen;
                console.log(finalvalueToScreenInt+' - '+finalvalueToScreen);
            } else {
                animateValue(compteur.id, 0, finalvalueToScreenInt, 100, finalvalueToScreen);
            }
        });
    }
}

getAnimateCompteurs();
// const interval = setInterval(function() {
//     getAnimateCompteurs(true);
// }, 3000);

function getAnimateCompteursV2(inbloucle = false){
    var compteurs = document.querySelectorAll('.compteur2');
    if( compteurs.length > 0 ){

        compteurs.forEach(function(compteur){
            var end = parseInt(compteur.getAttribute('data-end'));

            if( inbloucle ){
                compteur.innerHTML = finalvalueToScreen;
                console.log(finalvalueToScreenInt+' - '+finalvalueToScreen);
            } else {
                animateValue(compteur.id, 0, end, 100, end);
            }
        });
    }
}

getAnimateCompteursV2();